// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"131":"6dded7dc","194":"9dad8ef1","260":"785b609e","668":"7075a63a","762":"8fba3ebf","810":"085d5e07","811":"1a97a16e","902":"da461495","973":"bd757f6a","983":"8ab9cb96"}[chunkId] + ".js";
};